import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
  };

  return (
    <section id="index" className="w-full py-12 md:py-16 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            影视索引
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            快速浏览全站影视分类，找到你想看的类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.label}
              href="#index"
              onClick={handleClick}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 bg-background-50 border border-background-200/70 rounded-xl cursor-pointer no-underline transition-all duration-200 hover:border-primary-300/50 hover:shadow-sm"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-full ${item.color} text-white`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap group-hover:text-primary-500 transition-colors">
                {item.label}
              </span>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}